export enum OnyxStorageKey {
  MAP_LAYER_TYPE = 'onyxMapLayerType',
  THEME = 'onyxTheme',
}
